import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

/* Modified มาจาก
SelectProvince.js 
*/

export default function Asynchronous(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const { rhf, control, name } = props;

  //ทำงานเมื่อคลิกไปที่ช่อง
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      console.log('---call API edu-institution---');

      var config = {
        method: 'get',
        // url: 'https://null.free.mockoapp.net/getCategories',
        // url: 'http://10.40.77.42:3006/api/cis/ranking-position',
        url: '/api/cis/edu-institution',
      };

      axios(config)
        .then(function (response) {
          console.log('---edu-institution---', response.data);
          // response.data = response.data.filter((category) => category.name);
          response.data = response.data.map((category) => { return { codeSAP: category.institution_code, name: category.institution_name}});
          if (active) {
            setOptions([...response.data]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <rhf.Controller
      render={({ field, fieldState: { error }, value }) => (
        <Autocomplete
          {...field}
          id="branch-of-studies-select"
          options={options}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          getOptionLabel={(option) => option.name}
          onChange={(_, data) => field.onChange(data)}
          loading={loading}
          //Fix MUI: The value provided to Autocomplete is invalid. None of the options match with...
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
          //Fix Warning, Read SelectEduCertificate.js
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="ชื่อและที่ตั้งสถานศึกษา"
              variant="filled"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      )}
      name={name}
      control={control}
    />
  );
}
